import { LanguagesEnum } from 'abi-compliance-common-types';
import { useSession } from '@ghq-abi/auth-client-lib/client';

import type { UserCustomData } from '~/pages/api/auth/[...nextauth]';

export function useUser() {
  const { data: session } = useSession<UserCustomData>();

  return {
    employeeId: session?.user?.proxiedAs?.employeeId ?? session?.user.employeeId,
    name: session?.user?.proxiedAs?.name ?? session?.user.name,
    email: session?.user?.proxiedAs?.email ?? session?.user.email,
    zone: session?.user.proxiedAs?.zone ?? session?.user.zone,
    globalId: session?.user.proxiedAs?.globalId ?? session?.user.globalId,
    roles: session?.user.proxiedAs?.roles ?? session?.user.roles,
    managedZones: session?.user.proxiedAs?.zone ?? session?.user.zone,
    language: session?.user.language as keyof typeof LanguagesEnum,
    isProxied: !!session?.user.proxiedAs,
    band: session?.user.proxiedAs?.band ?? session?.user.band,
  };
}

export type User = ReturnType<typeof useUser>;
